class VariantCode extends HTMLElement {
  connectedCallback() {
    document.addEventListener('variant:change', (evt) => {
      if (evt.detail.variant === null) {
        return;
      }
      const variantJson = JSON.parse(document.getElementById('VariantCodes').innerText);
      const variantId = variantJson.variants[evt.detail.variant.id].code;

      if (variantId) {
        this.innerText = variantId;
        this.parentElement.classList.remove('hide');
      } else {
        this.parentElement.classList.add('hide');
      }
    });
  }
}

customElements.define('variant-code', VariantCode);

export default VariantCode;
